import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import styled from 'styled-components';
import get from 'lodash/get';

import LockedContent from 'components/LockedContent';
import NotebookContentComponent from 'components/Notebook/NotebookContent';

import { redirectToDistribution } from 'actions/distribution';

const MarketNotebookContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  line-height: 24px;
  grid-gap: 20px;

  .marketNotebookPhoto {
    width: 100%;
    height: 7rem;

    @media (max-width: 1200px) {
      height: 5rem;
    }

    @media (max-width: 845px) {
      width: 9rem;
      height: 6rem;
    }
  }

  .networkContent {
    display: inline;
    padding: 6px;
    margin-left: 8px;
    border-radius: 40%;
    background-color: rgba(31, 43, 55, 0.04);
    color: ${(props) => props.theme.colors['dark']};
  }

  .marketNotebookCity {
    font-size: 1rem;
    font-family: ${(props) => props.theme.fonts.oswald};
    color: #2b3d54;

    @media (max-width: 1500px) {
      font-size: 0.8rem;
    }
  }

  .marketNotebookDate {
    color: ${(props) => props.theme.colors['terra-cotta']};
    font-family: ${(props) => props.theme.fonts.oswald};
    white-space: nowrap;
    font-size: 0.9rem;
  }

  a.disabled-link {
    pointer-events: none;
  }

  @media (max-width: 845px) {
    grid-template-columns: 1fr 1.5fr;
    grid-gap: 16px;
  }
`;

const LinkContainer = styled.div`
  a.disabled-link {
    pointer-events: none;
  }
`;

const ImageContainer = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
`;

const MarketNoteBookComponent = ({
  marketNoteBook,
  redirectToDistribution
}) => {
  const { toRedirectDistribution } = marketNoteBook;
  const isBranded = false;

  let onClick = undefined;
  if (toRedirectDistribution) {
    onClick = () => {
      redirectToDistribution({ ...toRedirectDistribution, isBranded });
    };
  }

  return (
    <LockedContent locked={marketNoteBook.nbRestaurants === 0}>
      <LinkContainer>
        <Link
          to={toRedirectDistribution ? get(marketNoteBook, 'link') : '#'}
          className={!toRedirectDistribution ? 'disabled-link' : ''}
        >
          <MarketNotebookContainer onClick={onClick}>
            <div className="marketNotebookPhoto">
              <ImageContainer src={get(marketNoteBook, 'marketImagePath')} />
            </div>
            <NotebookContentComponent
              name={get(marketNoteBook, 'city')}
              network={get(marketNoteBook, 'networkCode')}
              date={get(marketNoteBook, 'date')}
            />
          </MarketNotebookContainer>
        </Link>
      </LinkContainer>
    </LockedContent>
  );
};

const mapDispatchToProps = (dispatch) => ({
  redirectToDistribution: (value) => dispatch(redirectToDistribution(value))
});

export default connect(() => ({}), mapDispatchToProps)(MarketNoteBookComponent);
